import React from 'react'
import { Link } from 'gatsby'
import styles from './footer.module.scss'

import Navigation from './navigation'

export default () => (
  <footer className={styles.footer}>
    <div className="wrapper">
      <div className={styles.footerInner}>
        <p className={`${styles.footerLegal}`}>
          Aberystwyth Gymnastics Club © {new Date().getFullYear()}
        </p>
        <Link to="/privacy">Privacy & Terms</Link>
      </div>
    </div>
  </footer>
)
